import { FC } from 'react';
import styled from 'styled-components';

import Button from '@/components/Button';
import SelectedImagesBadge from '@/pages/CoverImagesGenerator/components/SelectedImagesBadge';

const Box = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  gap: 16px;
  display: flex;
`;

const StyledButton = styled(Button)`
  height: 38px;
  font-size: 14px;
  padding: 0 24px;
`;

interface Props {
  selectedImages: number[];
  imagesCount: number;
  setSelectedImages: React.Dispatch<React.SetStateAction<number[]>>;
  onSelectAll: (value: React.SetStateAction<number[]>) => void;
}

const SelectionActions: FC<Props> = ({
  selectedImages,
  imagesCount,
  setSelectedImages,
  onSelectAll,
}) => {
  return (
    <Box>
      <StyledButton
        color="colorized"
        disabled={selectedImages.length === imagesCount}
        onClick={onSelectAll}
      >
        Select All
      </StyledButton>
      <StyledButton
        color="secondary"
        disabled={!selectedImages.length}
        onClick={() => setSelectedImages([])}
      >
        Unselect All
      </StyledButton>
      <SelectedImagesBadge
        selectedCount={selectedImages.length}
        imagesCount={imagesCount}
      />
    </Box>
  );
};

export default SelectionActions;
